import script from "./mediadetails.vue?vue&type=script&setup=true&lang=js"
export * from "./mediadetails.vue?vue&type=script&setup=true&lang=js"

import "./mediadetails.vue?vue&type=style&index=0&id=e41698ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e41698ba"]])

export default __exports__